import type { SVGProps } from "react";

export const DefaultConnectionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.2978e-06 2.35529C3.89779e-06 1.73149 0.247459 1.13317 0.688082 0.69161C1.12871 0.250051 1.7265 0.00132161 2.3503 0H10.5888C11.2126 0.00132161 11.8104 0.250051 12.251 0.69161C12.6917 1.13317 12.9391 1.73149 12.9391 2.35529V4.72555C12.9391 5.35021 13.1873 5.94929 13.629 6.39099C14.0707 6.83269 14.6698 7.08084 15.2944 7.08084H17.6447C18.2685 7.08084 18.8668 7.32829 19.3084 7.76892C19.7499 8.20954 19.9987 8.80734 20 9.43114V17.6497C19.9987 18.2735 19.7499 18.8713 19.3084 19.3119C18.8668 19.7525 18.2685 20 17.6447 20H9.41118C9.10211 20.0007 8.79597 19.9403 8.51024 19.8225C8.22451 19.7047 7.96482 19.5317 7.74605 19.3134C7.52727 19.0951 7.3537 18.8358 7.23528 18.5503C7.11685 18.2648 7.0559 17.9588 7.0559 17.6497V15.2944C7.0559 14.6711 6.80827 14.0733 6.3675 13.6325C5.92674 13.1917 5.32893 12.9441 4.70559 12.9441H2.3503C2.04123 12.9441 1.7352 12.8832 1.44973 12.7647C1.16425 12.6463 0.904931 12.4727 0.68662 12.254C0.46831 12.0352 0.295296 11.7755 0.177476 11.4898C0.0596565 11.204 -0.000650893 10.8979 5.2978e-06 10.5888V2.35529ZM8.38323 6.91617C7.99054 6.92271 7.61616 7.08332 7.34079 7.36335C7.06542 7.64339 6.91113 8.02043 6.91119 8.41317V12.1357C6.91113 12.5285 7.06542 12.9055 7.34079 13.1855C7.61616 13.4656 7.99054 13.6262 8.38323 13.6327H12.1058C12.5028 13.6327 12.8836 13.475 13.1643 13.1943C13.4451 12.9135 13.6028 12.5328 13.6028 12.1357V8.41317C13.6028 8.01614 13.4451 7.63537 13.1643 7.35463C12.8836 7.07388 12.5028 6.91617 12.1058 6.91617H8.38323Z"
      fill="url(#paint0_linear_default_icon)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_default_icon"
        x1="-0.509765"
        y1="0.499999"
        x2="22.9902"
        y2="21"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#635DFF" />
        <stop offset="1" stopColor="#3885FF" />
      </linearGradient>
    </defs>
  </svg>
);
